var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bestSellers"},[_c('div',{staticClass:"container bestSellers__container"},[_c('titleComponent',{attrs:{"data":_vm.titleData}}),_vm._v(" "),_c('productCarousel',{attrs:{"addItemToCard":_vm.addItemToCard,"data":_vm.data}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cc8338f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bestSellersBlock.vue
// module id = 232
// module chunks = 0